import { createSlice } from "@reduxjs/toolkit";
import authService from "../service/auth";

export const login = (param) => async (dispatch) => {
    return authService.login(param)
        .then(async (res) => {
            console.log('resp at slice', res)
            localStorage.setItem("token", res?.data?.token)
            return res;
        })
        .catch((error) => {

            localStorage.removeItem("token")
            throw error
        });
};

export const forgotPassword = (param) => async (dispatch) => {
    return authService.forgotPassword(param)
        .then(async (res) => {
            console.log('resp at slice', res)
            return res;
        })
        .catch((error) => {
            throw error
        });
};

export const setNewPassword = (param) => async (dispatch) => {
    return authService.newPassword(param)
        .then(async (res) => {
            console.log('resp at slice', res)
            return res;
        })
        .catch((error) => {
            throw error
        });
};

export const addExecutiveMsg = (param) => async (dispatch) => {
    return authService.addExecutiveMsg(param)
        .then(async (res) => {
            console.log('resp at slice', res)

            return res;
        })
        .catch((error) => {

            throw error
        });
};

export const updateTaxfile = (param) => async (dispatch) => {
    return authService.updateTaxfile(param)
        .then(async (res) => {
            console.log('resp at slice', res)

            return res;
        })
        .catch((error) => {

            throw error
        });
};

// export const addExecutiveMsgAll = (param) => async (dispatch) => {
//     return authService.addExecutiveMsgAll(param)
//         .then(async (res) => {
//             console.log('resp at slice', res)

//             return res;
//         })
//         .catch((error) => {

//             throw error
//         });
// };

export const addTemplate = (param) => async (dispatch) => {
    return authService.addTemplate(param)
        .then(async (res) => {
            console.log('resp at slice', res)

            return res;
        })
        .catch((error) => {

            throw error
        });
};

export const addExecutive = (param) => async (dispatch) => {
    return authService.addExecutive(param)
        .then(async (res) => {
            console.log('resp at slice', res)

            return res;
        })
        .catch((error) => {

            throw error
        });
};

export const updateTaxfileStatus = (param) => async (dispatch) => {
    return authService.updateTaxfileStatus(param)
        .then(async (res) => {
            console.log('resp at slice', res)
            // dispatch(setInputs(res?.data.response));
            // localStorage.setItem("token", res?.data?.response?.token)
            return res;
        })
        .catch((error) => {
            // dispatch(authSuccess(null));
            // localStorage.removeItem("token")
            throw error
        });
};

const initialState = {
    user: null,
    taxfileFilter:[]
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        setTaxfileFilter: (state, action) => {
            state.taxfileFilter = action.payload
        }
    }
});

export const {
    setTaxfileFilter
} = userSlice.actions;

export default userSlice.reducer;
